import { Alert } from '@arco-design/web-react'
import type { OptionsAPI } from './useOptions'
import GlobalModelSection from './model/GlobalModelSection'
import ChannelAffinitySection from './model/ChannelAffinitySection'
import GeminiModelSection from './model/GeminiModelSection'
import ClaudeModelSection from './model/ClaudeModelSection'
import GrokModelSection from './model/GrokModelSection'

export default function ModelSetting({ options }: { options: OptionsAPI }) {
  return (
    <div>
      <Alert
        type="warning"
        className="mb-4"
        content={
          <div className="text-sm space-y-1">
            <div className="font-medium">职责边界</div>
            <ul className="list-disc pl-4 space-y-0.5 text-gray-600">
              <li>模型元数据、供应商与上游同步 →「模型管理」(/console/models)</li>
              <li>渠道级 model_mapping、分组能力 →「渠道管理」(/console/channel)</li>
              <li>分组倍率、固定价、auto 路由 →「分组/倍率」</li>
              <li>本页仅保存后端 config manager 真实读取的 global / gemini / claude / grok / 渠道亲和 key</li>
            </ul>
            <div className="text-xs text-gray-500 mt-2">
              历史遗留 key（CustomModels、ModelMapping 等）已移除；ModelMapping 请在渠道表字段配置。
            </div>
          </div>
        }
      />
      <GlobalModelSection options={options} />
      <ChannelAffinitySection options={options} />
      <GeminiModelSection options={options} />
      <ClaudeModelSection options={options} />
      <GrokModelSection options={options} />
    </div>
  )
}
